var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FFF3EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4167 17.8922C27.274 16.2562 26.6756 14.693 25.6893 13.3799C24.7031 12.0668 23.3685 11.0565 21.837 10.4636C20.3055 9.87068 18.6385 9.71895 17.0252 10.0256C15.4119 10.3323 13.9168 11.085 12.7097 12.1985C11.0982 13.679 10.1025 15.7115 9.92061 17.8922C9.90577 18.0648 9.92698 18.2386 9.98287 18.4026C10.0388 18.5666 10.1281 18.7171 10.2453 18.8447C10.3625 18.9723 10.5049 19.0742 10.6635 19.1438C10.8221 19.2134 10.9935 19.2494 11.1667 19.2493H18.0417V23.6243C18.0417 24.2873 18.3051 24.9232 18.7739 25.392C19.2428 25.8609 19.8787 26.1243 20.5417 26.1243C21.2047 26.1243 21.8406 25.8609 22.3095 25.392C22.7783 24.9232 23.0417 24.2873 23.0417 23.6243C23.0417 23.4585 22.9759 23.2995 22.8586 23.1823C22.7414 23.0651 22.5825 22.9993 22.4167 22.9993C22.2509 22.9993 22.092 23.0651 21.9748 23.1823C21.8575 23.2995 21.7917 23.4585 21.7917 23.6243C21.7917 23.9558 21.66 24.2737 21.4256 24.5081C21.1912 24.7426 20.8732 24.8743 20.5417 24.8743C20.2102 24.8743 19.8922 24.7426 19.6578 24.5081C19.4234 24.2737 19.2917 23.9558 19.2917 23.6243V19.2493H26.1667C26.3403 19.2499 26.5121 19.2144 26.6711 19.145C26.8302 19.0756 26.9731 18.9738 27.0907 18.8461C27.2083 18.7185 27.298 18.5677 27.3541 18.4035C27.4103 18.2393 27.4316 18.0652 27.4167 17.8922ZM11.1667 17.9993C11.2899 16.597 11.8035 15.2574 12.6492 14.1321C13.4949 13.0069 14.639 12.1411 15.9517 11.633C17.2644 11.1248 18.6932 10.9946 20.0762 11.2571C21.4591 11.5195 22.7408 12.1642 23.7761 13.118C25.1595 14.3858 26.0133 16.1291 26.1667 17.9993H11.1667Z",
    fill: "#FF7A21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.597d4a616f24c3e10f069c6ddab6e9e7.svg";
export { ForwardRef as ReactComponent };